import cn from 'classnames';
import { FC, Fragment, PropsWithChildren, useEffect, useRef, useState } from 'react';

import { LeftOutlined, RightOutlined } from '@ant-design/icons';

import styles from './OverflowContainer.module.css';

interface Props {
  itemsWithoutPadding?: boolean;
}

const OverflowContainer: FC<PropsWithChildren<Props>> = ({
  itemsWithoutPadding = false,
  children,
}) => {
  const wrapper = useRef<HTMLDivElement>(null);
  const scrollable = useRef<HTMLDivElement>(null);
  const [pointer, setPointer] = useState(0);
  const [showButtons, setShowButtons] = useState(false);
  const [elementWidth, setElementWidth] = useState<number | null>(null);

  useEffect(() => {
    const wrapperWidth = wrapper?.current?.clientWidth;
    let scrollableWidth = scrollable?.current?.clientWidth;

    if (wrapperWidth !== undefined && scrollableWidth !== undefined) {
      scrollableWidth = scrollableWidth - 16;

      if (scrollableWidth > wrapperWidth) {
        const childWidth = scrollable.current?.firstElementChild?.clientWidth;

        if (childWidth) {
          setElementWidth(childWidth);
        }

        setShowButtons(true);
      }
    }
  }, []);

  useEffect(() => {
    if (elementWidth) {
      const left = elementWidth * pointer;
      wrapper?.current?.scrollTo({ left, behavior: 'smooth' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pointer]);

  return (
    <div className={styles.root}>
      <div ref={wrapper} className={styles.wrap}>
        <div
          ref={scrollable}
          className={cn(styles.items, itemsWithoutPadding ? styles.noPadding : '')}
        >
          {children}
        </div>
      </div>
      {showButtons && (
        <Fragment>
          <button
            onClick={() => {
              setPointer(pointer - 1);
            }}
            disabled={pointer === 0}
            className={cn(styles.button, styles.leftButton)}
            type="button"
          >
            <LeftOutlined />
          </button>
          <button
            onClick={() => {
              setPointer(pointer + 1);
            }}
            className={cn(styles.button, styles.rightButton)}
            type="button"
          >
            <RightOutlined />
          </button>
        </Fragment>
      )}
    </div>
  );
};

export default OverflowContainer;
